<template>
  <div>
    <div slot="title">
      <h2 v-if="idFormatoCuestionario == 0">Nuevo Cuestionario</h2>
      <h2 v-else>Editar Cuestionario</h2>

      <!--<h2 v-if="idFormatoCuestionario==0">Nuevo Cuestionario</h2>
      <h2 v-else>Editar Cuestionario</h2>-->
    </div>
    <div slot="main">
      <div class="container-fluid">
        <div class="row" style="margin-top:50px;">
          <div class="col-6">
            <input type="text" class="form-control" placeholder="Nombre del Cuestionario" v-model="nombreCuestionario" />
          </div>
        </div>
        <div class="row" style="margin-top:30px;">
          <div class="col-6">
            <select class="form-control" v-model="tipoCuestionario" v-bind:disabled="idFormatoCuestionario!=0">
              <option selected disabled value=0>Tipo de Cuestionario</option>
              <option value=1>Cuestionario de Autoevaluación</option>
              <option value=2>Cuestionario para Iguales</option>
              <option value=3>Cuestionario para Superiores</option>
              <option value=4>Cuestionario para Subordinados</option>
            </select>
          </div>
        </div>
        <div class="row" style="margin-top:30px">
          <div class="col-3"></div>
          <div class="col-3">
            <input type="button" class="form-control" value="Guardar" v-bind:disabled="validarFormulario" @click="guardar" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import comun from '@/../static/js/comun'
  import enumeraciones from '@/../static/js/enumeraciones'
  import api from '@/../static/js/api'
  import axios from 'axios'

  export default {
    props: {
      idFormatoCuestionario: {
        type: Number,
        default: 0
      }
    },
    data() {
      return {
        nombreCuestionario: "",
        tipoCuestionario: 0,
        tipoInstrumento: 1
      }
    },
    components: {

    },
    methods: {
      crearCuestionario: function () {
        var peticion = {
          "EsPrueba": false,
          "NombreCuestionario": this.nombreCuestionario,
          "IdTipoCuestionario": parseInt(this.tipoCuestionario),
          "IdTipoInstrumento": this.tipoInstrumento,
          "Activo": true
        };
        console.log(peticion)
        axios.post(api.conexion + api.SISEVA.funcion.CrearCuestionario, peticion).then(response => {
          if (response.data.SiHayError == false) {
            this.$router.push({
              name: 'AsignarPreguntas',
              params: { idFormatoCuestionario: response.data.idCuestionario }
            })
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });
      },
      actualizarCuestionario: function () {
        var peticion = {
          "EsPrueba": false,
          "idFormatoCuestionario": this.idFormatoCuestionario,
          "NombreCuestionario": this.nombreCuestionario,
          "IdTipoCuestionario": parseInt(this.tipoCuestionario),
          "IdTipoInstrumento": this.tipoInstrumento
        };
        //console.log(peticion)
        axios.post(api.conexion + api.SISEVA.funcion.ActualizarFormatoCuestionario, peticion).then(response => {
          if (response.data.SiHayError == false) {
            console.log(response);
            this.$router.push("/SISEVA/AsignarPreguntas")
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });
      },
      guardar: function () {
        if (this.idFormatoCuestionario == 0) {
          this.crearCuestionario()
        } else {
          this.actualizarCuestionario()
        }
      },
      getInfoCuestionario: function () {
        var peticion = {
          "esPrueba": false,
          "idFormatoCuestionario": this.idFormatoCuestionario
        }
        axios.post(api.conexion + api.SISEVA.funcion.GetFormatoCuestionario, peticion).then(response => {
          if (response.data.SiHayError == false) {
            this.nombreCuestionario = response.data.FormatoCuestionario.nombreCuestionario
            this.tipoCuestionario = response.data.FormatoCuestionario.idTipoCuestionario
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });
      }

    },
    computed: {
      validarFormulario: function () {
        return this.nombreCuestionario.length <= 0 || this.tipoCuestionario <= 0
      }
    },
    mounted: function () {
      if (this.idFormatoCuestionario != null && this.idFormatoCuestionario != 0) {
        this.getInfoCuestionario();
      }
    }
  }

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/SISEVA/Psicologia/NuevoCuestionario.vue